import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import BussinesTravel from "./tabs/BussinesTravel";
import { Wrapper } from "../styled";

const businessTripsTabs = [
{
    title: "Командировки",
    component: <BussinesTravel/>,
}
];

const BussinesTrips: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {businessTripsTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {businessTripsTabs[tab].component}
    </Wrapper>
);
};

export default BussinesTrips;
